import { PlaybookReportType } from '@driftt/api-types'
import { pathOr } from 'ramda'

import { ALL_CHAT_PLAYBOOK_TYPES } from 'constants/types'

export const bucketPlaybooksByType = (playbooks = []) => {
  const abmPlaybooks = []
  const abmPlaybookIds = []
  const nonSpecialPlaybooks = []
  const nonSpecialPlaybookIds = []
  const outboundPlaybooks = []
  const outboundPlaybookIds = []

  for (let i = 0, len = playbooks.length; i < len; i++) {
    const current = playbooks[i] || {}
    const id = pathOr(null, ['id'], current)
    const reportType = pathOr(null, ['reportType'], current)

    if (reportType === PlaybookReportType.ABM) {
      abmPlaybookIds.push(id)
      abmPlaybooks.push(current)
    } else if (
      reportType === PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS
    ) {
      outboundPlaybookIds.push(id)
      outboundPlaybooks.push(current)
    } else if (
      ALL_CHAT_PLAYBOOK_TYPES.includes(reportType) ||
      'MEETING_BOOKING_BOT'
    ) {
      nonSpecialPlaybookIds.push(id)
      nonSpecialPlaybooks.push(current)
    }
  }

  return {
    idPriorityList: [
      ...outboundPlaybookIds,
      ...abmPlaybookIds,
      ...nonSpecialPlaybookIds,
    ],
    playbookTypes: {
      ABM: abmPlaybooks,
      nonSpecial: nonSpecialPlaybooks,
      outbound: outboundPlaybooks,
    },
  }
}
